import { Directive } from '@angular/core';
import { GtmTrackProductClickDirectiveDef } from '@df/module-gtm/gtm-track-product-click.directive.def';

/**
 * @deprecated Dispatch DfEvent productClick instead
 */
@Directive({
    selector: '[gtmTrackProductClick]',
    standalone: true
})
export class GtmTrackProductClickDirective extends GtmTrackProductClickDirectiveDef {}
